import { render, staticRenderFns } from "./proKeywords.vue?vue&type=template&id=630c2c30&scoped=true"
import script from "./proKeywords.vue?vue&type=script&lang=js"
export * from "./proKeywords.vue?vue&type=script&lang=js"
import style0 from "./proKeywords.vue?vue&type=style&index=0&id=630c2c30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630c2c30",
  null
  
)

export default component.exports